module.exports = __webpack_public_path__ + "img/star_1_5.913c01e6.png";